import * as React from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";
import Icon from "@cloudscape-design/components/icon";

// The original skyscraper help panel, unchanged, serving the public site.
export const LegacySlider = () => {
  return (
    <HelpPanel
      footer={
        <div>
          <h3>
            Learn more <Icon name="external" size="inherit" />
          </h3>
          <p>
            The values shown on the graph are <strong>NOT FACT CHECKED</strong>{" "}
            for a more accurate count, see the link below:
          </p>
          <ul>
            <li>
              <a href="https://www.skyscrapercenter.com/countries">
                Link to accurate count
              </a>
            </li>
          </ul>
        </div>
      }
      header={<h2>More information</h2>}
    >
      <div>
        <p>
          This page visualizes the number of skyscrapers (buildings ≥ 150 m) in
          selected countries across multiple years. The bar chart shows the
          current dataset, and the Table of changes is prepared to track any
          edits once live updates are enabled.
        </p>

        <h4>Customizing the layout</h4>
        <p>
          The panels on this page use a draggable board layout. You can drag
          items to rearrange them and resize cards to fit the view you prefer.
        </p>

        <h4>Interactive data updates — coming soon</h4>
        <p>
          You'll soon be able to update skyscraper counts directly from the page
          using a simple form. Once live, the page will support real-time
          updates and a full change history.
        </p>

        <ul>
          <li>Submit new values for any country</li>
          <li>See the chart update instantly</li>
          <li>
            Every edit will be logged in the Table of changes with the previous
            value, new value, and timestamp
          </li>
          <li>Data will be stored in a database instead of static values</li>
        </ul>
      </div>
    </HelpPanel>
  );
};
